import { Button } from "@mantine/core";
import saveAs from "file-saver";
import { useCallback, useState } from "react";
import api from "../../../../../api";
import {
  type ShowErrorToastFn,
  useToast
} from "../../../../../mantine/notifications/useToast";
import urls from "../../../../../urls";
import type { EnergyDataImportRequest } from "../../../EnergyDataUploadFlow/EnergyDataUpload";

const ZIP_FILENAME = "opti Node Dateien.zip";

interface EnergyDataUploadFilesToDownload {
  ids: string[];
}

interface DownloadButtonProps {
  dataImportRequests: EnergyDataImportRequest[];
  onClearSelection: () => void;
  setLoading: (loading: boolean) => void;
}

async function download(
  showErrorToast: ShowErrorToastFn,
  dataImportRequests: EnergyDataImportRequest[]
) {
  const data: EnergyDataUploadFilesToDownload = {
    ids: dataImportRequests.map(({ id }) => id)
  };

  try {
    const response = await api.post(urls.api.energyDataUploadFiles(), data, {
      responseType: "blob",
      transformResponse: []
    });

    const blob = new Blob([response.data]);

    const filename =
      dataImportRequests.length === 1
        ? dataImportRequests[0].energyDataFile.name
        : ZIP_FILENAME;

    saveAs(blob, filename);
  } catch (e) {
    showErrorToast(e);
  }
}

function DownloadButton({
  dataImportRequests,
  onClearSelection,
  setLoading
}: DownloadButtonProps) {
  const { showErrorToast } = useToast();
  const [isInProgress, setIsInProgress] = useState(false);

  const handleClick = useCallback(async () => {
    setIsInProgress(true);
    setLoading(true);

    await download(showErrorToast, dataImportRequests);
    onClearSelection();
    setIsInProgress(false);
    setLoading(false);
  }, [dataImportRequests, setLoading, onClearSelection, showErrorToast]);
  return (
    <Button
      disabled={dataImportRequests.length === 0 || isInProgress}
      onClick={handleClick}
    >
      Download
    </Button>
  );
}

export { DownloadButton };
